export enum AIAgentStatus {
  INITIAL = 'initial',
  RUNNING = 'running',
  IDLE = 'idle',
}

export interface AIAgentModel {
  id: string
  type: string
  status: AIAgentStatus
  context: { [key: string]: any }
}
